import { CSSProperties } from 'react';

/**
 * Attributes for a Password input, which carries a login for another site (Fruugo's Retailer
 * Portal) rather than one for ours.
 *
 * A real password field makes browser password managers offer to save it, or to generate a new
 * one, against this site, leaving the seller with a "Parcel2Go" password that is really their
 * Fruugo one. Browsers ignore autocomplete="off" on password fields, and Google Password Manager
 * and Apple Keychain have no opt-out attribute, so the field is a plain text input masked with
 * CSS instead: managers recognise passwords by type="password". The third-party managers' own
 * opt-outs are added as well, and phone keyboards are told not to capitalise or correct it, which
 * would change the password.
 *
 * -webkit-text-security is non-standard but supported in Chrome, Edge, Safari and Firefox 114+.
 */
export const otherSitePasswordInputProps = {
  style: { WebkitTextSecurity: 'disc' } as CSSProperties,
  autoCapitalize: 'off',
  autoCorrect: 'off',
  'data-1p-ignore': 'true',
  'data-lpignore': 'true',
  'data-bwignore': 'true',
  'data-form-type': 'other'
};
